import * as types from 'store/actions/types';
import * as fetchProductMemberships from 'store/actions/product-memberships/fetchProductMemberships';
import * as createProductMembership from 'store/actions/product-memberships/createProductMembership';
import * as deleteProductMembership from 'store/actions/product-memberships/deleteProductMembership';
import * as updateProductMembership from 'store/actions/product-memberships/updateProductMembership';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import utils from 'helpers/utils';

function* failureMessage({ error }) {
    const { message } = error.response || {};

    yield put(showNotification(message || 'general.error', 'warning'));
}

function* fetchProductMembershipsAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/product-memberships`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchProductMemberships.fetchProductMembershipsSuccess(response));
    } catch (error) {
        yield put(fetchProductMemberships.fetchProductMembershipsFailure(error));
    }
}

function* fetchProductMembershipAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/product-memberships/${ id }`;

        const response = yield apiClient.read(url);

        yield put(fetchProductMemberships.fetchProductMembershipSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }

    } catch (error) {
        yield put(fetchProductMemberships.fetchProductMembershipFailure(error));

        if (utils.isFunction(error)) {
            yield onError(error);
        }
    }
}

function* createProductMembershipAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/product-memberships`;

        const response = yield apiClient.create(url, values);

        yield put(createProductMembership.createProductMembreshipSuccess(response));

        yield onSuccess();
    } catch (error) {
        yield put(createProductMembership.createProductMembreshipFailure(error));

        yield onError(error);
    }
}

function* createMembershipSuccessAsync() {
    yield put(showNotification('resources.memberships.messages.created.success', 'success'));
}

function* deleteProductMembershipAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/product-memberships/${ id }`;

        yield apiClient.delete(url);

        yield put(deleteProductMembership.deleteProductMembershipSuccess(payload));

        yield onSuccess();
    } catch (error) {
        yield put(deleteProductMembership.deleteProductMembershipFailure(error));

        if (utils.isFunction(error)) {
            yield onError(error);
        }
    }
}

function* updateProductMembershipAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/product-memberships/${ id }`;

        const response = yield apiClient.patch(url, values);

        yield put(updateProductMembership.updateProductMembershipSuccess(payload, response));

        yield onSuccess();
    } catch (error) {
        yield put(updateProductMembership.updateProductMembershipFailure(error));

        yield onError(error);
    }
}

function* updateProductMembershipSuccessAsync() {
    yield put(showNotification('resources.memberships.messages.updated.success', 'success'));
}

function* deleteProductMembershipSuccessAsync() {
    yield put(showNotification('resources.memberships.messages.deleted.success', 'success'));
}

export default function* productMembershipsSagas() {
    yield [
        takeEvery(types.FETCH_PRODUCT_MEMBERSHIPS, fetchProductMembershipsAsync),
        takeEvery(types.FETCH_PRODUCT_MEMBERSHIPS_FAILURE, failureMessage),

        takeEvery(types.FETCH_PRODUCT_MEMBERSHIP, fetchProductMembershipAsync),
        takeEvery(types.FETCH_PRODUCT_MEMBERSHIP_FAILURE, failureMessage),

        takeEvery(types.CREATE_PRODUCT_MEMBERSHIP, createProductMembershipAsync),
        takeEvery(types.CREATE_PRODUCT_MEMBERSHIP_FAILURE, failureMessage),
        takeEvery(types.CREATE_PRODUCT_MEMBERSHIP_SUCCESS, createMembershipSuccessAsync),

        takeEvery(types.UPDATE_PRODUCT_MEMBERSHIP, updateProductMembershipAsync),
        takeEvery(types.UPDATE_PRODUCT_MEMBERSHIP_FAILURE, failureMessage),
        takeEvery(types.UPDATE_PRODUCT_MEMBERSHIP_SUCCESS, updateProductMembershipSuccessAsync),

        takeEvery(types.DELETE_PRODUCT_MEMBERSHIP, deleteProductMembershipAsync),
        takeEvery(types.DELETE_PRODUCT_MEMBERSHIP_FAILURE, failureMessage),
        takeEvery(types.DELETE_PRODUCT_MEMBERSHIP_SUCCESS, deleteProductMembershipSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/productMembershipSagas.js